import { DateTimePicker } from '@mui/x-date-pickers';
import moment from 'moment';

const disableFutureDates = (date) => date.isAfter(moment(), 'day');

const ReportDateTimePicker = ({ label, value, onChange, maxDateTime, minDateTime, ...props }) => (
    <DateTimePicker
        label={label}
        value={value}
        onChange={onChange}
        maxDateTime={maxDateTime}
        minDateTime={minDateTime}
        ampm={false}
        shouldDisableDate={disableFutureDates}
        slotProps={{ textField: { size: 'small' } }}
        {...props}
    />
);

export default ReportDateTimePicker;
